var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.attributes.length ||
      (_vm.possibleUnitCombinationIds.length > 1 && _vm.isContentVisible)
        ? [
            _vm._l(_vm.attributes, function (attribute, index) {
              return _c(
                "div",
                { key: index, staticClass: "col-12 variation-select" },
                [
                  _vm.attributeAsTable(attribute.attributeId)
                    ? _c(
                        "div",
                        {
                          staticClass: "border mb-3",
                          style: {
                            "--color-hover": "var(--" + _vm.appearance + ")",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "title",
                              class: "bg-" + _vm.appearance,
                              staticStyle: {
                                "border-bottom": "1px solid #dbdbdb",
                                height: "37px",
                                "line-height": "37px",
                                "padding-left": "15px",
                                "font-size": "17px",
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(attribute.name) +
                                  "\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "variations" },
                            _vm._l(
                              _vm.sortVariationsByAttribute(
                                _vm.variationsData.infoVariations,
                                attribute.attributeId
                              ),
                              function (variation, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass:
                                      "d-flex align-items-center py-2 position-relative",
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectAttribute(
                                          variation.attributes[0].attributeId,
                                          variation.attributes[0].valueId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        " position-absolute h-100 w-100 table-element",
                                      class: [
                                        variation.attributes[0].valueId ===
                                        _vm.selectedAttributes[
                                          variation.attributes[0].attributeId
                                        ]
                                          ? "selected"
                                          : "",
                                      ],
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "button_select",
                                        staticStyle: {
                                          width: "8%",
                                          height: "100%",
                                          "text-align": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "table-option border",
                                            class: [
                                              variation.attributes[0]
                                                .valueId ===
                                              _vm.selectedAttributes[
                                                variation.attributes[0]
                                                  .attributeId
                                              ]
                                                ? "opt-selected  bg-" +
                                                  _vm.appearance
                                                : "",
                                            ],
                                          },
                                          [
                                            variation.attributes[0].valueId ===
                                            _vm.selectedAttributes[
                                              variation.attributes[0]
                                                .attributeId
                                            ]
                                              ? _c("div", [_vm._v("✓")])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "name_variant",
                                        staticStyle: {
                                          width: "18%",
                                          "overflow-wrap": "break-word",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            variation.attributes[0].value
                                              .backendName
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "grundpreis text-right px-1",
                                        staticStyle: {
                                          width: "28%",
                                          "overflow-wrap": "break-word",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            variation.prices.default.basePrice
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text-right px-2",
                                        staticStyle: {
                                          width: "46%",
                                          "overflow-wrap": "break-word",
                                        },
                                      },
                                      [
                                        (!!variation.prices.rrp &&
                                          variation.prices.rrp.unitPrice.value >
                                            variation.prices.default.unitPrice
                                              .value) ||
                                        (!!variation.prices.specialOffer &&
                                          !!variation.prices.default &&
                                          variation.prices.default.unitPrice
                                            .value >
                                            variation.prices.specialOffer
                                              .unitPrice.value)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "preis px-2",
                                                staticStyle: {
                                                  "font-size": "0.8rem",
                                                  "overflow-wrap": "break-word",
                                                },
                                              },
                                              [
                                                !!variation.prices.specialOffer
                                                  ? [
                                                      _c("s", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "itemCrossPrice"
                                                            )(
                                                              variation.prices
                                                                .default
                                                                .unitPrice
                                                                .formatted,
                                                              true
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  : [
                                                      _c("s", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "itemCrossPrice"
                                                            )(
                                                              variation.prices
                                                                .rrp.unitPrice
                                                                .formatted
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                              ],
                                              2
                                            )
                                          : _c("div", {
                                              staticClass: "preis px-2",
                                              staticStyle: {
                                                width: "26%",
                                                "font-size": "0.8rem",
                                                "overflow-wrap": "break-word",
                                              },
                                            }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "preis font-weight-bold",
                                            staticStyle: {
                                              "overflow-wrap": "break-word",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  variation.prices.default.price
                                                    .formatted
                                                ) +
                                                "\n                "
                                            ),
                                            _c("sup", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemFootnote1"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    : attribute.type === "dropdown"
                    ? _c(
                        "div",
                        {
                          ref: "attributesContaner",
                          refInFor: true,
                          staticClass: "input-unit",
                        },
                        [
                          _c(
                            "select",
                            {
                              staticClass: "custom-select",
                              attrs: {
                                id: "custom-select_" + attribute.name,
                                "data-testing": "variation-select-dropdown",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.selectAttribute(
                                    attribute.attributeId,
                                    $event.target.value
                                  )
                                },
                              },
                            },
                            [
                              _vm.addPleaseSelectOption || !_vm.hasSelection
                                ? _c("option", { domProps: { value: -1 } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemPleaseSelect"
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasEmptyOption ||
                              _vm.selectedAttributes[attribute.attributeId] ===
                                null
                                ? _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: null,
                                        selected:
                                          _vm.selectedAttributes[
                                            attribute.attributeId
                                          ] === null,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemNoSelection"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(attribute.values, function (value) {
                                return _c(
                                  "option",
                                  {
                                    key: value.attributeValueId,
                                    domProps: {
                                      value: value.attributeValueId,
                                      selected:
                                        value.attributeValueId ===
                                        _vm.selectedAttributes[
                                          attribute.attributeId
                                        ],
                                    },
                                  },
                                  [
                                    _vm.isAttributeSelectionValid(
                                      attribute.attributeId,
                                      value.attributeValueId,
                                      true
                                    )
                                      ? [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(value.name) +
                                              "\n            "
                                          ),
                                        ]
                                      : _vm.isAttributeSelectionValid(
                                          attribute.attributeId,
                                          value.attributeValueId,
                                          false
                                        )
                                      ? [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemNotSalableAttribute",
                                                  { name: value.name }
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemInvalidAttribute",
                                                  { name: value.name }
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ],
                                  ],
                                  2
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.isTextCut(attribute.name),
                                  expression: "isTextCut(attribute.name)",
                                },
                              ],
                              attrs: {
                                for: "custom-select_" + attribute.name,
                                "data-toggle": "tooltip",
                                "data-placement": "top",
                                title: attribute.name,
                                "data-testing":
                                  "variation-select-dropdown-label",
                              },
                            },
                            [_vm._v(_vm._s(attribute.name))]
                          ),
                        ]
                      )
                    : attribute.type === "box" || attribute.type === "image"
                    ? _c("div", [
                        _c(
                          "span",
                          {
                            staticClass: "text-muted",
                            attrs: { "data-testing": "attribute-name" },
                          },
                          [_vm._v(_vm._s(attribute.name) + ":")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b",
                          { attrs: { "data-testing": "attribute-value" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getSelectedAttributeValueName(attribute)
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "v-s-boxes py-3",
                            class: { images: attribute.type === "image" },
                          },
                          [
                            _vm.addPleaseSelectOption
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "v-s-box bg-white empty-option",
                                    class: {
                                      active:
                                        _vm.selectedAttributes[
                                          attribute.attributeId
                                        ] === -1,
                                      invalid: !_vm.isAttributeSelectionValid(
                                        attribute.attributeId,
                                        -1
                                      ),
                                    },
                                    attrs: {
                                      "data-testing": "variation-select-box",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectAttribute(
                                          attribute.attributeId,
                                          -1
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "mx-3" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemPleaseSelect"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasEmptyOption
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "v-s-box bg-white empty-option",
                                    class: {
                                      active:
                                        _vm.selectedAttributes[
                                          attribute.attributeId
                                        ] === null,
                                      invalid: !_vm.isAttributeSelectionValid(
                                        attribute.attributeId,
                                        null,
                                        true
                                      ),
                                    },
                                    attrs: {
                                      "data-testing": "variation-select-box",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectAttribute(
                                          attribute.attributeId,
                                          null
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "mx-3" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemNoSelection"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(attribute.values, function (value) {
                              return _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: true,
                                      expression: "true",
                                    },
                                  ],
                                  key: value.attributeValueId,
                                  staticClass: "v-s-box bg-white",
                                  class: {
                                    active:
                                      value.attributeValueId ===
                                      _vm.selectedAttributes[
                                        attribute.attributeId
                                      ],
                                    invalid: !_vm.isAttributeSelectionValid(
                                      attribute.attributeId,
                                      value.attributeValueId,
                                      true
                                    ),
                                  },
                                  attrs: {
                                    "data-testing": "variation-select-box",
                                    "data-html": "true",
                                    "data-toggle": "tooltip",
                                    "data-placement": "top",
                                    "data-original-title": _vm.getTooltip(
                                      attribute,
                                      value
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectAttribute(
                                        attribute.attributeId,
                                        value.attributeValueId
                                      )
                                    },
                                  },
                                },
                                [
                                  attribute.type === "box"
                                    ? _c("span", { staticClass: "mx-3" }, [
                                        _vm._v(_vm._s(value.name)),
                                      ])
                                    : _c("img", {
                                        staticClass: "p-1",
                                        attrs: {
                                          src: value.imageUrl,
                                          alt: value.name,
                                        },
                                      }),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            _vm._v(" "),
            _vm.possibleUnitCombinationIds.length > 1 && _vm.isContentVisible
              ? _c("div", { staticClass: "col-12 variation-select" }, [
                  _c("div", { staticClass: "input-unit" }, [
                    _c(
                      "select",
                      {
                        staticClass: "custom-select",
                        attrs: {
                          id: "unit-combination-ids-select",
                          "data-testing": "variation-select-unit",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.selectUnit($event.target.value)
                          },
                        },
                      },
                      _vm._l(
                        _vm.possibleUnitCombinationIds,
                        function (unitCombinationId) {
                          return _c(
                            "option",
                            {
                              key: unitCombinationId,
                              domProps: {
                                value: unitCombinationId,
                                selected:
                                  parseInt(unitCombinationId) ===
                                  _vm.selectedUnit,
                              },
                            },
                            [
                              _vm.isUnitSelectionValid(unitCombinationId)
                                ? [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.possibleUnits[unitCombinationId]
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemInvalidAttribute",
                                            {
                                              name: _vm.possibleUnits[
                                                unitCombinationId
                                              ],
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ],
                            ],
                            2
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: {
                          for: "unit-combination-ids-select",
                          "data-testing": "variation-select-unit-label",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.singleItemContent")
                          )
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]
        : [_vm._t("default")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }